import React, { useCallback, useEffect } from 'react'
import ConsignmentItemsTableRow from './ConsignmentItemsTableRow'
import { ConsignmentItem } from '../../consignment-item/models/types'
import ConsignmentItemsTablePlaceHolderRows from './ConsignmentItemsTablePlaceHolderRows'

interface ConsignmentItemsTableProps {
  isLoading: boolean
  consignmentItemsLoading: boolean
  consignmentItems: ConsignmentItem[]
  expectedItemCount: number
}

function ConsignmentItemsTable({
  isLoading,
  consignmentItemsLoading,
  consignmentItems,
  expectedItemCount,
} : ConsignmentItemsTableProps) {
  const [expanded, setExpanded] = React.useState<Set<number>>(
    () => (consignmentItems.length <= 5
      ? new Set(consignmentItems.map((ci) => ci.id))
      : new Set()),
  )

  useEffect(() => {
    if (!consignmentItems?.length) return
    setExpanded(consignmentItems.length <= 5
      ? new Set(consignmentItems.map((ci) => ci.id))
      : new Set())
  }, [consignmentItems])

  const toggle = useCallback((id: number) => {
    setExpanded((prev) => {
      const next = new Set(prev)
      if (next.has(id)) {
        next.delete(id)
      } else {
        next.add(id)
      }
      return next
    })
  }, [])

  const isShowPlaceHolderRows = isLoading || consignmentItemsLoading

  return (
    <div className="col-12 transit-sidebar__goods-items">
      {isShowPlaceHolderRows
        ? (
          <ConsignmentItemsTablePlaceHolderRows numberOfItems={Math.min(expectedItemCount, 5)} />
        ) : (
          consignmentItems.map(
            (consignmentItem, itemIndex) => (
              <ConsignmentItemsTableRow
                key={consignmentItem.id}
                consignmentItem={consignmentItem}
                isExpanded={expanded.has(consignmentItem.id)}
                itemSequenceNumber={itemIndex}
                onRowToggle={() => toggle(consignmentItem.id)}
              />
            ),
          )
        )}
    </div>
  )
}

export default ConsignmentItemsTable
